import { Component, inject, Inject, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ListDropdownService } from '@vueling-ng/vy-ds/src/lib/components/composed/header';
import { ListDropdownItem } from '@vueling-ng/vy-ds/src/lib/components/globals/list-dropdown';
import { SIDEPANEL_DATA, SidePanelRef } from '@vueling-ng/vy-ds/src/lib/components/globals/side-panel';
import { CurrencyService } from 'app/services/internal/currency/currency.service';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';

export interface LanguageCurrencyData {
  languages: ListDropdownItem[];
  currencies: ListDropdownItem[];
}

@Component({
  selector: 'app-lang-currency-selector',
  templateUrl: './lang-currency-selector.component.html',
  styleUrls: ['./lang-currency-selector.component.scss']
})
export class LangCurrencySelectorComponent implements OnInit, OnDestroy {
  private readonly _translateService = inject(TranslateService);
  private readonly _listDropdownService = inject(ListDropdownService);
  private readonly _currencyService = inject(CurrencyService);

  public languages: ListDropdownItem[] = this.data.languages;
  public currencies: ListDropdownItem[] = this.data.currencies;

  public languageSubject: BehaviorSubject<ListDropdownItem | null> = new BehaviorSubject<ListDropdownItem | null>(null);
  public currencySubject: BehaviorSubject<ListDropdownItem | null> = new BehaviorSubject<ListDropdownItem | null>(null);

  private selectedLanguage = '';
  private selectedCurrency = '';

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    @Inject(SIDEPANEL_DATA) private data: LanguageCurrencyData,
    private readonly _sidePanelRef: SidePanelRef
  ) {}

  public ngOnInit(): void {
    this._listDropdownService.getLanguage().pipe(takeUntil(this.destroy$)).subscribe(this.languageSubject);
    this._listDropdownService.getCurrency().pipe(takeUntil(this.destroy$)).subscribe(this.currencySubject);
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public confirmSelection(): void {
    this.updateLLangCurrents();
    this._sidePanelRef.close();
  }

  public updateLanguage(event: ListDropdownItem): void {
    this.selectedLanguage = event.value;
    this.languageSubject.next(event);
  }

  public updateCurrency(event: ListDropdownItem): void {
    this.selectedCurrency = event.value;
    this.currencySubject.next(event);
  }

  private updateLLangCurrents(): void {
    if (this.selectedCurrency) {
      this._currencyService.setCurrency(this.selectedCurrency ?? this._currencyService.currentCurrency());
    }
    if (this.selectedLanguage) {
      this._translateService.use(this.selectedLanguage ?? this._translateService.currentLang);
    }
  }
}
